var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9093 0H14.182C13.5796 0 13.0911 0.488438 13.0911 1.09092C13.0911 1.69341 13.5796 2.18184 14.182 2.18184H20.2757L9.04707 13.4105C8.62103 13.8365 8.62103 14.5272 9.04707 14.9532C9.26003 15.1662 9.53921 15.2727 9.8184 15.2727C10.0976 15.2727 10.3768 15.1663 10.5898 14.9532L21.8184 3.72459V9.8182C21.8184 10.4207 22.3069 10.9091 22.9094 10.9091C23.5119 10.9091 24.0003 10.4207 24.0003 9.8182V1.09092C24.0002 0.488438 23.5118 0 22.9093 0Z",
    fill: "#758ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 10.9091C17.943 10.9091 17.4545 11.3975 17.4545 12V21.8182H2.1818V6.54544H12C12.6025 6.54544 13.0909 6.05701 13.0909 5.45452C13.0909 4.85204 12.6025 4.36365 12 4.36365H1.09092C0.488438 4.36365 0 4.85208 0 5.45457V22.9091C0 23.5116 0.488438 24 1.09092 24H18.5455C19.148 24 19.6364 23.5116 19.6364 22.9091V12C19.6364 11.3975 19.1479 10.9091 18.5454 10.9091Z",
    fill: "#758ABD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7516615a.svg";
export { ForwardRef as ReactComponent };